import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import LaunchMilestoneTimeline from './LaunchMilestoneTimeline';
import PilotRegionPerformance from './PilotRegionPerformance';
import AdoptionRateChart from './AdoptionRateChart';
import LaunchChecklistTable from './LaunchChecklistTable';
const ProductLaunchTrackerDashboard: React.FC = () => {
  const kpis = [{
    title: 'Launch Readiness %',
    value: '87%',
    change: '+12%',
    isPositive: true,
    subtitle: 'Overall readiness score'
  }, {
    title: 'Launch Budget vs Actual',
    value: '₹142 Cr',
    change: '-₹8 Cr',
    isPositive: true,
    subtitle: 'Under budget'
  }, {
    title: 'Expected 6-Month Revenue',
    value: '₹385 Cr',
    change: '+15%',
    isPositive: true,
    subtitle: 'Post-launch projection'
  }];
  return <div data-id="element-7937">
      <DescriptionPanel title="New Product Launch Tracker" description="End-to-end tracking of new product launches from concept to market. Monitor launch readiness, milestone completion, pilot region performance, and OEM customer adoption to ensure successful product introductions and rapid market penetration." insights={['Overall launch readiness at 87% - on track for Q1 FY26 launch', 'LED Headlamp Pro pilot in West region showing 24% adoption rate', 'Launch budget under control at ₹142 Cr vs ₹150 Cr planned', 'Expected 6-month post-launch revenue projected at ₹385 Cr']} data-id="element-7938" />
      {/* KPI Tiles */}
      <div className="mb-8" data-id="element-7939">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-7940">
          Launch Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-7941">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-7942">
              <div className="flex flex-col h-full" data-id="element-7943">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-7944">
                  {kpi.title}
                </div>
                <div className="text-xs text-gray-400 mb-3" data-id="element-7945">{kpi.subtitle}</div>
                <div className="text-4xl font-bold text-gray-900 mb-3" data-id="element-7946">
                  {kpi.value}
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-7947">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-7948" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-7949" />}
                  {kpi.change} vs plan
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Launch Milestone Timeline - Full Width */}
      <LaunchMilestoneTimeline data-id="element-7950" />
      {/* Main Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-7951">
        <PilotRegionPerformance data-id="element-7952" />
        <AdoptionRateChart data-id="element-7953" />
      </div>
      {/* Launch Checklist Table */}
      <LaunchChecklistTable data-id="element-7954" />
    </div>;
};
export default ProductLaunchTrackerDashboard;